import { render, staticRenderFns } from "./AddNewWidget.vue?vue&type=template&id=af8c346e"
import script from "./AddNewWidget.vue?vue&type=script&lang=js"
export * from "./AddNewWidget.vue?vue&type=script&lang=js"
import style0 from "./AddNewWidget.vue?vue&type=style&index=0&id=af8c346e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports